import { Box, Typography, Chip, IconButton, Button } from "@mui/material";
import { BusinessCenter } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const CategoryItem = ({ data }) => {
  const navigate = useNavigate();
  const {
    banner_pic,
    refer,
    title,
    info,
    total_listing,
    categories = [],
  } = data;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        sx={{
          height: 300,
          borderRadius: 4,
          overflow: "hidden",
          position: "relative",
          boxShadow: 4,
        }}
      >
        {/* Full Image */}
        <Box
          component="img"
          src={banner_pic}
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top",
            position: "absolute",
            inset: 0,
            zIndex: 1,
          }}
        />

        {/* Bottom Gradient Overlay */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: "60%",
            background:
              "linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent)",
            zIndex: 2,
          }}
        />

        {/* Bottom Content */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            zIndex: 3,
            color: "#fff",
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={700}
            sx={{
              color: "#fff",
              mb: 0,
              // textShadow: "1px 1px 2px rgba(0,0,0,0.85)",
              textShadow: "2px 2px 3px rgba(0,0,0,0.9)",
            }}
          >
            {title || "Project Name Here"}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.85)",
              fontSize: "13px",
              lineHeight: 1.4,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {info.length > 30
              ? info.slice(0, 27) + "..."
              : info ||
                "Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti, iure."}
          </Typography>

          {/* Chips */}
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {categories.map((cat, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Chip
                  label={cat}
                  size="small"
                  sx={{
                    fontWeight: 600,
                    bgcolor: "rgba(255,255,255,0.2)",
                    color: "#fff",
                    borderRadius: "999px",
                    px: 1.5,
                    fontSize: "11px",
                    border: "1px solid rgba(255,255,255,0.3)",
                  }}
                />
              </motion.div>
            ))}
          </Box>

          {/* View Details Button */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            style={{ marginTop: "4px", alignSelf: "flex-start" }}
          >
            <Button
              size="small"
              variant="outlined"
              sx={{
                borderColor: "rgba(255,255,255,0.5)",
                textShadow: "2px 2px 3px rgba(0,0,0,0.9)",
                color: "#fff",
                fontSize: "11px",
                textTransform: "none",
                px: 1.5,
                borderRadius: 10,
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                  borderColor: "#fff",
                },
              }}
              onClick={() => navigate("/explore/" + refer)}
            >
              View Details
            </Button>
          </motion.div>
        </Box>

        {/* Top Icon */}
        <motion.div
          whileHover={{ scale: 1.2 }}
          style={{
            position: "absolute",
            top: 12,
            left: 12,
            zIndex: 3,
          }}
        >
          <IconButton
            sx={{
              bgcolor: "rgba(0,0,0,0.5)",
              color: "#fff",
              "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
              boxShadow: 2,
            }}
          >
            <BusinessCenter fontSize="small" />
          </IconButton>
        </motion.div>
      </Box>
    </motion.div>
  );
};

export default CategoryItem;
